import { Header, Footer } from '@/components/layout'
import { Hero, Features, Integration, Comparison, Pricing, CTA } from '@/components/sections'
import { SEO, StructuredData } from '@/components/seo'

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Developer-First Authentication Platform"
        description="JumpstoneAuth is a developer-first authentication platform. Add secure login, SSO, MFA, and user management to your app in minutes, not months. Free up to 1,000 MAU."
        canonical="/"
        structuredData={[
          StructuredData.softwareApplication(),
          StructuredData.webPage(
            'JumpstoneAuth - Developer-First Authentication Platform',
            'Developer-first authentication platform with passwordless login, MFA, SSO, and user management.',
            '/'
          ),
          {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'JumpstoneAuth',
            description: 'Developer-first authentication platform for modern applications',
            brand: {
              '@type': 'Brand',
              name: 'JumpstoneAuth',
            },
            offers: {
              '@type': 'AggregateOffer',
              lowPrice: '0',
              highPrice: '499',
              priceCurrency: 'USD',
              offerCount: '3',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.9',
              reviewCount: '87',
              bestRating: '5',
              worstRating: '1',
            },
          },
        ]}
      />
      <Header />
      <main>
        <Hero />
        <Features />
        <Integration />
        <Comparison />
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}

